import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { snoozePhoneCapturePromptRequest } from 'tio-data/requests/phone-capture-prompt';
import type { PhoneCapturePromptSnoozeKind } from 'tio-data/requests/phone-capture-prompt';
import type { Store } from '@warp-drive/core';

/**
 * The phone ask's one snooze, shared by the post-login overlay and the dashboard card.
 * The session's user payload predates any dismissal made in it, so this remembers one.
 */
export default class PhoneCaptureSnoozeService extends Service {
  @service declare store: Store;

  @tracked isSnoozed = false;

  /**
   * Records a dismissal, then hides both prompts for the rest of the session.
   *
   * @param platform attributed onto the funnel event
   * @param surface the prompt dismissed, for the funnel; omitted means the overlay
   * @throws when the server did not record it, leaving both prompts as they were
   */
  async snooze(kind: PhoneCapturePromptSnoozeKind, platform?: string, surface?: string) {
    await this.store.request(snoozePhoneCapturePromptRequest(kind, platform, surface));
    this.isSnoozed = true;
  }
}

declare module '@ember/service' {
  interface Registry {
    'phone-capture-snooze': PhoneCaptureSnoozeService;
  }
}
